module.exports = __webpack_public_path__ + "img/background-middle.0ac33b1c.jpg";